import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { seApi } from "./features/api/apiSlice";
import apiKeyReducer from "./features/api/apiKeySlice";
import journeyReducer from "./features/journey/journeySlice";
import filtersReducer from "./features/filters/filtersSlice";

// Each <UnitTable /> mount creates its own store so multiple unit tables on
// the same page don't share journey/filter state — otherwise opening the
// journey on one table would also open it on every other table.
export const createStore = () => {
    const store = configureStore({
        reducer: {
            apiKey: apiKeyReducer,
            journey: journeyReducer,
            filters: filtersReducer,
            [seApi.reducerPath]: seApi.reducer,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(seApi.middleware),
    });

    setupListeners(store.dispatch);

    return store;
};

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
